import { render, staticRenderFns } from "./APK.vue?vue&type=template&id=9c0c1922&"
import script from "./APK.vue?vue&type=script&lang=js&"
export * from "./APK.vue?vue&type=script&lang=js&"
import style0 from "./APK.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "APK.vue"
export default component.exports